// JsFromRoutes CacheKey d6c962f5d1f7c3fe4bbd40960c4de112
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/employers/home'),
}
